module.exports = __webpack_public_path__ + "static/media/MSMEBen4.ee7fbf72.svg";